import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Btn, Pill, Table } from "@/admin/AdminLayout";
import { Spinner } from "@/components/common";

const TONE: Record<string, string> = { high: "red", medium: "amber", low: "neutral", info: "green" };
const TYPES = ["All", "Page", "Blog post", "Collection", "Product"];
const LEVELS: [string, string][] = [["all", "All issues"], ["high", "Must fix"], ["medium", "Should fix"], ["low", "Nice to fix"], ["info", "Hidden from Google"]];

export function SeoHealth() {
  const [d, setD] = useState<any>(null);
  const [type, setType] = useState("All");
  const [level, setLevel] = useState("all");
  const load = () => { setD(null); api.get("/admin-x/seo/health").then((r) => setD(r.data)); };
  useEffect(load, []);
  if (!d) return <Spinner />;
  const rows = d.items.filter((r: any) => (type === "All" || r.type === type) && (level === "all" ? r.issues.some((i: any) => i.level !== "info") : r.issues.some((i: any) => i.level === level)));
  return (
    <div className="space-y-6" data-testid="seo-health">
      <div className="flex flex-wrap items-center gap-3">
        <div className="bg-white border border-neutral-200 px-5 py-3" data-testid="seo-health-summary"><span className="font-display text-3xl">{d.checked - d.with_issues}</span><span className="text-sm text-neutral-500"> of {d.checked} pages look good</span></div>
        {[["high", "Must fix"], ["medium", "Should fix"], ["low", "Nice to fix"]].map(([k, l]) => <Pill key={k} tone={TONE[k]}>{l}: {d.counts[k] || 0}</Pill>)}
        <Btn ghost onClick={load} className="ml-auto" data-testid="seo-health-recheck">Check again</Btn>
      </div>
      <div className="flex flex-wrap gap-3">
        <select value={type} onChange={(e) => setType(e.target.value)} className="border border-neutral-300 bg-white px-3 py-2 text-sm" data-testid="seo-health-type">{TYPES.map((t) => <option key={t}>{t}</option>)}</select>
        <select value={level} onChange={(e) => setLevel(e.target.value)} className="border border-neutral-300 bg-white px-3 py-2 text-sm" data-testid="seo-health-level">{LEVELS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <span className="text-xs text-neutral-500 self-center">{rows.length} shown</span>
      </div>
      <Table head={["Type", "Page", "Title shown on Google", "What to fix", ""]} testId="seo-health-table">
        {rows.map((r: any) => (
          <tr key={r.url} data-testid={`seo-health-row-${r.url.replace(/[^a-z0-9]+/gi, "-")}`}>
            <td className="px-4 py-3 text-xs whitespace-nowrap">{r.type}</td>
            <td className="px-4 py-3"><a href={r.url} target="_blank" rel="noreferrer" className="hover:underline">{r.name}</a><div className="text-[11px] text-neutral-500">{r.url}</div></td>
            <td className="px-4 py-3 text-xs max-w-[280px]">{r.title}</td>
            <td className="px-4 py-3"><div className="flex flex-wrap gap-1">{r.issues.map((i: any) => <Pill key={i.text} tone={TONE[i.level]}>{i.text}</Pill>)}</div></td>
            <td className="px-4 py-3 text-right"><Link to={r.edit} className="text-xs underline underline-offset-4 whitespace-nowrap" data-testid="seo-health-fix">Fix</Link></td>
          </tr>
        ))}
      </Table>
      {!rows.length && <p className="text-sm text-neutral-500" data-testid="seo-health-empty">Nothing to fix here.</p>}
    </div>
  );
}
